// @ts-nocheck
import AccountSettingsReducer, {
    GreifAccountSettingsPageReducer,
} from "@store/Framework/Store/Greif/Pages/AccountSettings/AccountSettingsReducer";
import CartReducer, { GreifPagesCartActions } from "@store/Framework/Store/Greif/Pages/Cart/CartReducer";
import checkoutShippingReducer, {
    GreifPagesCheckoutShippingActions,
} from "@store/Framework/Store/Greif/Pages/CheckoutShipping/CheckoutShippingReducer";
import ContactUsReducer, {
    GreifContactUsPageReducer,
} from "@store/Framework/Store/Greif/Pages/ContactUs/ContactUsReducer";
import FeatureNotesListReducer, {
    GreifFeatureNotesPagesActions,
} from "@store/Framework/Store/Greif/Pages/FeatureNotesList/FeatureNotesListReducer";
import ProductDetailsReducer, {
    GreifProductDetailPageActions,
} from "@store/Framework/Store/Greif/Pages/ProductDetails/ProductDetailsReducer";
import OrderChangeReducer, {
    GreifOrderChangePagesActions,
} from "@store/Framework/Store/Greif/Pages/OrderChange/OrderChangeReducer";
import OrderComplaintReducer, {
    GreifOrderComplaintPagesActions,
} from "@store/Framework/Store/Greif/Pages/OrderComplaint/OrderComplaintReducer";
import ResetPasswordReducer, {
    GreifOrderResetPasswordPageActions,
} from "@store/Framework/Store/Greif/Pages/ResetPassword/ResetPasswordReducer";
import ReviewAndSubmitReducer, {
    GreifPagesSubmitAndReviewActions,
} from "@store/Framework/Store/Greif/Pages/ReviewAndSubmit/ReviewAndSubmitReducer";
import ShipmentHistoryReducer, {
    GreifShipmentHistoryPageActions,
} from "@store/Framework/Store/Greif/Pages/ShipmentHistory/ShipmentHistoryReducer";
import TaxExemptionCertificatesReducer, {
    GreifTaxExemptionCertificatesPagesActions,
} from "@store/Framework/Store/Greif/Pages/TaxExemptionCertificates/TaxExemptionCertificatesReducer";
import TECNotificationReducer, {
    GreifTECNotificationPagesActions,
} from "@store/Framework/Store/Greif/Pages/TECNotification/TECNotificationReducer";
import TrailerTrackingV2Reducer, {
    GreifTrailerTrackingV2PageActions,
} from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Reducer";
import OrderHistoryReducer, {
    GreifOrderHistoryPageActions,
} from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryReducer";
import InvoiceHistoryReducer, {
    GreifInvoiceHistoryPageActions,
} from "@store/Framework/Store/Greif/Pages/InvoiceHistory/InvoiceHistoryReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    checkoutShipping: checkoutShippingReducer,
    orderComplaint: OrderComplaintReducer,
    taxExemptionCertificates: TaxExemptionCertificatesReducer,
    cart: CartReducer,
    reviewAndSubmit: ReviewAndSubmitReducer,
    tecNotification: TECNotificationReducer,
    orderChange: OrderChangeReducer,
    contactUs: ContactUsReducer,
    accountSettings: AccountSettingsReducer,
    featureNotesList: FeatureNotesListReducer,
    resetPassword: ResetPasswordReducer,
    shipmentHistory: ShipmentHistoryReducer,
    productDetails: ProductDetailsReducer,
    trailerTrackingV2: TrailerTrackingV2Reducer,
    orderHistory: OrderHistoryReducer,
    invoiceHistory: InvoiceHistoryReducer,
};

export type GreifPagesActions =
    | GreifPagesCartActions
    | GreifPagesCheckoutShippingActions
    | GreifOrderComplaintPagesActions
    | GreifTaxExemptionCertificatesPagesActions
    | GreifTECNotificationPagesActions
    | GreifPagesSubmitAndReviewActions
    | GreifOrderChangePagesActions
    | GreifContactUsPageReducer
    | GreifAccountSettingsPageReducer
    | GreifFeatureNotesPagesActions
    | GreifOrderResetPasswordPageActions
    | GreifShipmentHistoryPageActions
    | GreifProductDetailPageActions
    | GreifTrailerTrackingV2PageActions
    | GreifOrderHistoryPageActions
    | GreifInvoiceHistoryPageActions;
export default combineReducers(pagesReducers);
